import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link, useParams, useLocation, navigate } from '@reach/router'
import { URLSearchParams } from 'universal-url'

import { IconPrevious } from '../../icons'
import Button from '../../button'

import { dateString } from '../../../utils/date'

import './index.styl'

const SingleNews = ({ pageData, sitePrefix }) => {
  return (
    <div className="single-news">
      <div className="single-news__head">
        <div className="single-news__date">{dateString(pageData.time)}</div>
        <div className="single-news__title">{pageData.title}</div>
      </div>
      <div className="single-news__content"
        dangerouslySetInnerHTML={{ __html: pageData.content}}
      />
      <div className="single-news__aside">
        <Button
          style="outline-secondary"
          target="_self"
          href={(typeof window !== `undefined` && document.referrer) || `${sitePrefix}/about/news-events/`}
          className="single-news__back-btn"
        >
          <IconPrevious />
          Back to previous page
        </Button>
      </div>
    </div>
  )
}

SingleNews.propTypes = {}

export default SingleNews
